import $ from 'jquery';
import slick from 'slick-carousel';

const defaultSettings = {
  mobileFirst: true,
  arrows: false,
  dots: true,
  centermode: false,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
      },
    },
  ],
};

class Carousel {
  constructor(target, settingsOverride = {}, responsiveOverride = {}) {
    this.slick = null;
    this.target = target;
    this.settings = {
      ...defaultSettings,
      ...settingsOverride
    };

    Object.entries(responsiveOverride).forEach(([key, value]) => {
      const index = this.settings.responsive.findIndex(r => r.breakpoint === key);
      if (index > -1) {
        // modify existing breakpoint settings
        const currentSettings = this.settings.responsive[index].settings;
        if (value === 'unslick') {
          this.settings.responsive[index].settings = value;
        } else {
          this.settings.responsive[index].settings = {
            ...currentSettings,
            ...value
          };
        }
      } else {
        // push new breakpoint setting
        this.settings.responsive.push({
          breakpoint: key,
          settings: value
        });
      }
    });
  }

  init(callbackFn) {
    this.slick = $(this.target).slick(this.settings);
    if (callbackFn) callbackFn();
  }

  goTo(slideNum, skipAnimation = false) {
    $(this.slick).slick('slickGoTo', slideNum, skipAnimation);
  }

  setChangeHandler(fn) {
    $(this.slick).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      fn(nextSlide);
    });
  }
}

export default Carousel;
